import { TransactionType } from '../proto/generated/order'
import { OptionType, SecurityCategory_CategoryCode } from '../proto/generated/security'
import { TradeOrder } from '../reducer/strategyBuilder.reducer'

export type OptionChainOrderSides = Record<'call' | 'put', 'buy' | 'sell'>

export const getOptionChainOrderSidesForRowKey = (
    rowKey: string,
    tradeOrders: TradeOrder[]
): OptionChainOrderSides | undefined => {
    const result: Partial<OptionChainOrderSides> = {}
    for (const tO of tradeOrders) {
        if (!tO.selected || tO.security.categoryCode !== SecurityCategory_CategoryCode.OPTIONS) continue
        const topKey = tO.security.code.slice(0, -2) + 'CE'
        if (topKey !== rowKey) continue
        const key = tO.security.optionType === OptionType.CE ? 'call' : 'put'
        result[key] = tO.transactionType === TransactionType.BUY ? 'buy' : 'sell'
    }
    return result.call || result.put ? (result as OptionChainOrderSides) : undefined
}

export const getOptionChainOrderClassSuffix = (
    rowKey: string,
    highlightSide: 'call' | 'put' | null,
    tradeOrders: TradeOrder[]
): string => {
    if (!highlightSide) return ''
    const orderSide = getOptionChainOrderSidesForRowKey(rowKey, tradeOrders)?.[highlightSide]
    if (!orderSide) return ''
    return highlightSide === 'call'
        ? ` call-${orderSide}-order-row `
        : ` put-${orderSide}-order-row `
}
